import { ComprobanteDetailDto } from "./comprobanteDetailDto.model";

/**
 * Un comprobante de liquidación dentro de una transferencia.
 * Es el detalle que se ve al expandir la fila.
 */
export class LiquidacionDeTransferencia {
  public idComprobante: number = 0
  public numeroComprobante: string = ""
  public estado: string = ""
  public anulado: boolean = false
  public propiedad: string = ""
  public numeroContrato: number = 0
  public inquilino: string = ""
  public totalDebe: number = 0
  public totalHaber: number = 0
  public totalPago: number = 0
  public total: number = 0
  public comprobanteDetailDto!: ComprobanteDetailDto
}

/**
 * Una transferencia al propietario: agrupa todas las liquidaciones que se le
 * emitieron el mismo día, sin importar cuántas propiedades sean.
 *
 * Representa el pago único que la inmobiliaria le hace al propietario, que es
 * como funciona en la realidad: una sola transferencia por el total.
 */
export class TransferenciaPropietario {
  /** Clave de agrupación: idPropietario + fecha */
  public clave: string = ""

  public idPropietario: number = 0
  public propietario: string = ""
  public fechaEmision: string = ""

  /** Liquidaciones que componen la transferencia */
  public liquidaciones: LiquidacionDeTransferencia[] = []

  public cantidadLiquidaciones: number = 0
  public cantidadAnuladas: number = 0

  /** Totales, ya excluidos los comprobantes anulados */
  public totalDebe: number = 0
  public totalHaber: number = 0
  public totalPago: number = 0

  /** Lo que efectivamente se transfiere */
  public totalATransferir: number = 0

  // Desglose guardado al emitir. Sólo disponible en liquidaciones nuevas: si
  // alguna del grupo no lo tiene, tieneDesglose queda en false y la vista
  // muestra un guion en vez de una suma parcial que no cerraría.
  public totalCalculo: number = 0
  public totalComisiones: number = 0
  public tieneDesglose: boolean = true
}
